import { FC } from 'react'

import { AppDialog } from '@/Components/AppDialog'
import { Divider } from '@/Components/Divider'
import PhotoIcon from '@/Components/icons/pkg-photo.svg?react'
import { Button } from '@/Components/ui/button'
interface PhotoConfirmationDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  isLoading?: boolean
}

export const PhotoConfirmationDialog: FC<PhotoConfirmationDialogProps> = ({ isOpen, onClose, onConfirm, isLoading = false }) => {
  return (
    <AppDialog
      isOpen={isOpen}
      onOpenChange={onClose}
      title={
        <div className='space-y-4 text-center'>
          <div className='mx-auto h-6 w-6'>
            <PhotoIcon className='text-icon-primary h-full w-full' />
          </div>
          <div className='text-lg font-medium'>רוצה לראות מה יש בחבילה שלך?</div>
        </div>
      }
      dialogContentClassName='max-w-md !p-0'
    >
      <div className='flex flex-col items-center gap-4 px-6 pt-2 text-center'>
        <p className='text-text-secondary mx-auto max-w-[210px] text-sm leading-relaxed'>
          אנחנו נצלם עבורך את החבילה ונעלה את התמונה לחשבון שלך. היא תופיע ממש כאן ותהיה זמינה להורדה
        </p>
        <div className='bg-button-primary-selected-segment text-text-secondary rounded-full px-3 py-2'>
          <p className='text-text-secondary text-xs'>השירות כרוך בתשלום של $5 שיופיע בחשבון לאחר הביצוע</p>
        </div>
      </div>
      <Divider className='my-6' />
      <div className='flex justify-center px-6 pb-6'>
        <Button loading={isLoading} onClick={onConfirm} disabled={isLoading} className='w-full max-w-[335px]' size='lg'>
          כן, צלמו לי את החבילה!
        </Button>
      </div>
    </AppDialog>
  )
}
